/**
 * Shared MUI theme.
 *
 * The only job of this theme is to make MUI's responsive tooling
 * (`useMediaQuery(theme.breakpoints...)`, `sx={{ prop: { xs, md, lg } }}`) agree with
 * the breakpoints the app shell has always used, so both systems can coexist.
 *
 * IMPORTANT — the breakpoint values below are deliberately NOT MUI's defaults
 * (600/900/1200/1536). They mirror `BREAKPOINTS` in `hooks/useResponsive.js`, which
 * already drives the sidebar drawer and the compact header. If these two ever
 * disagree, the sidebar and the page body will disagree about what "mobile" means.
 *
 * Deliberately NOT included:
 *  - `CssBaseline`. The app ships its own reset in `index.css`; layering MUI's reset
 *    on top of it changes desktop typography, body margins and background colours.
 *    Desktop must stay pixel-identical, so the theme carries breakpoints only.
 *  - Palette/typography overrides. Existing pages are styled with inline styles, so
 *    theming MUI components would have no effect on them and would only create a
 *    second, competing source of truth.
 *
 * Usage guidance for this codebase lives in
 * `documentation/README_RESPONSIVE_PASS.md`.
 */

import { createTheme } from '@mui/material/styles';
import { BREAKPOINTS } from './hooks/useResponsive';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: BREAKPOINTS.xs, //    0 - phones (portrait)
      sm: BREAKPOINTS.sm, //  576 - phones (landscape)
      md: BREAKPOINTS.md, //  768 - tablets; the "adapt below this" line
      lg: BREAKPOINTS.lg, //  992 - desktops
      xl: BREAKPOINTS.xl, // 1200 - large desktops
    },
  },
});

export default theme;
